import request from '@/utils/request'

// 查询列表
export function listScpSopSupplierCapacity (query) {
  return request({
    url: '/scp/scpSopSupplierCapacity/list',
    method: 'get',
    params: query
  })
}
// 删除列表
export function listDeleteScpSopSupplierCapacity (ids) {
  return request({
    url: `/scp/scpSopBasicData/${ids}`,
    method: 'delete'
  })
}

// 查询列表数据
export function listScpSopBasicData (query) {
    return request({
      url: '/scp/scpSopBasicData/list',
      method: 'get',
      params: query
    })
  }
// 新增期间版本查询
export function newScpSopBasicData (query) {
    return request({
      url: '/scp/scpSopBasicData',
      method: 'post',
      data: query
    })
  }
  // 查询供应商产能列表
export function apiScpSopSupplierCapacityList (query) {
    return request({
      url: '/scp/scpSopSupplierCapacity/list',
      method: 'get',
      params: query
    })
  }
// 查询供应商产能列表
export function apiSendScpFcSporadic (query) {
  return request({
    url: '/external/scm/getCompanySplitRatioReport',
    method: 'get',
    params: query
  })
}
